import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './index.css';

const VARIANT_PRIMARY = 'primary';
const VARIANT_SECONDARY = 'secondary';
const VARIANT_POSITIVE = 'positive';
const VARIANT_NEGATIVE = 'negative';
const VARIANT_GRADIENT = 'gradient';

const propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  type: PropTypes.string,
  id: PropTypes.string,
  small: PropTypes.bool,
  variant: PropTypes.oneOf([
    VARIANT_PRIMARY,
    VARIANT_SECONDARY,
    VARIANT_POSITIVE,
    VARIANT_NEGATIVE,
    VARIANT_GRADIENT,
  ]),
  noBorder: PropTypes.bool,
  isLoading: PropTypes.bool,
  coloredBg: PropTypes.bool,
  fullWidth: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  className: PropTypes.string,
  oval: PropTypes.bool,
};

const defaultProps = {
  type: 'button',
  variant: VARIANT_PRIMARY,
  id: '',
  onClick: () => {},
  disabled: false,
  secondary: false,
  noBorder: false,
  small: false,
  coloredBg: false,
  isLoading: false,
  fullWidth: false,
  className: null,
  oval: false,
};

const Button = props => {
  const {
    id,
    children,
    onClick,
    type = 'button',
    variant,
    disabled,
    noBorder,
    small,
    coloredBg,
    fullWidth,
    isLoading,
    className,
    oval,
  } = props;

  const btnClass = classNames(
    'Button',
    {
      'Button--secondary': variant === VARIANT_SECONDARY,
      'Button--positive': variant === VARIANT_POSITIVE,
      'Button--negative': variant === VARIANT_NEGATIVE,
      'Button--small': small,
      'Button--no_border': noBorder,
      'Button--colored_bg': coloredBg,
      'Button--full_width': fullWidth,
      'Button--is_loading': isLoading,
      'Button--gradient': variant === VARIANT_GRADIENT,
      'Button--oval': oval,
    },
    className,
  );

  return (
    <button
      id={id}
      type={type}
      className={btnClass}
      onClick={onClick}
      disabled={disabled || isLoading}
    >
      {children}
    </button>
  );
};

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default Button;



// WEBPACK FOOTER //
// ../ui-components/components/Button/index.jsx